import { Component, Input, Output, EventEmitter, input } from '@angular/core';
import { AppModule } from '../../app.module';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer, Subscription } from 'rxjs';
import { IncidentService } from '../incident.service';
import { Document, UploadingFile } from '../../models/incident';
import { AuthService } from '../../auth.service';
import { UserType } from '../enums';

export interface UploadFileStatus {
  name: string;
  status: 'pending' | 'success' | 'error';
  document?: Document;
  errorMessage?: string;
}

@Component({
  selector: 'app-file-uploader',
  imports: [AppModule],
  templateUrl: './file-uploader.html',
  styleUrl: './file-uploader.less'
})
export class FileUploader {
  @Input() public incidentId: number = 0;
  @Input() public documentClassification: number = 1; // Default to Proof of Work
  @Output() public uploadedDocuments = new EventEmitter<Document[]>();
  
  public isReadonly: boolean = false;
  public uploadFiles: UploadFileStatus[] = [];
  private documents: Document[] = [];
  private uploadingCount: number = 0;

  constructor(private incidentService: IncidentService, private authService: AuthService) {
    
  }

  // Override default upload behavior to prevent automatic HTTP POST
  public customRequest = (item: any): Subscription => {
    const file = item.file as File;
    
    // Add file to tracking list with pending status
    const fileStatus: UploadFileStatus = {
      name: file.name,
      status: 'pending'
    };
    this.uploadFiles.push(fileStatus);
    
    this.uploadingCount++;
    this.isReadonly = true;
    
    // Convert and upload the file
    const subscription = this.convertFileToBase64(file).subscribe({
      next: (base64: string) => {          
        // Upload the file
        this.uploadFileToApi(fileStatus, base64);
      },
      error: (error) => {
        this.uploadingCount--;
        if (this.uploadingCount === 0) {
          this.isReadonly = false;
        }
        fileStatus.status = 'error';
        fileStatus.errorMessage = error.message || error;
      }
    });
    
    return subscription;
  };

  private convertFileToBase64(file: File): Observable<string> {
    return new Observable((observer: Observer<string>) => {
      const reader = new FileReader();
      
      reader.onload = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      
      reader.onerror = (error) => {
        observer.error(error);
      };
      
      reader.readAsDataURL(file);
    });
  }

  private uploadFileToApi(fileStatus: UploadFileStatus, base64: string): void {
    let subCategoryId = 4; // Default to Other
    if (this.authService.user?.userType === UserType.callcenterOperator) {
      subCategoryId = 5; // Breakdown Details
    } 

    console.log("Class", this.documentClassification);
    
    const fileData: UploadingFile = {
      name: fileStatus.name,
      base64: base64,
      incidentId: this.incidentId,
      createdByUserId: this.authService.user!.userId,
      documentClassificationId: this.documentClassification,
      subCategoryId: subCategoryId
    };
    
    this.incidentService.uploadFile(fileData, this.incidentId).subscribe({
      next: (document: Document) => {
        this.documents.push(document);
        this.uploadingCount--;
        
        if (this.uploadingCount === 0) {
          this.isReadonly = false;
        }
        
        fileStatus.status = 'success';
        fileStatus.document = document;
        
        this.uploadedDocuments.emit([...this.documents]);
      },
      error: (error) => {
        this.uploadingCount--;
        
        if (this.uploadingCount === 0) {
          this.isReadonly = false;
        }
        
        fileStatus.status = 'error';
        fileStatus.errorMessage = error.message || error;
      }
    });
  }

}
